// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1Xh1t","header":"ReportDetails_header__2D3qS","title":"ReportDetails_title__2t0EJ","left":"ReportDetails_left__w2wpK"};